import { JATOTheme } from '@jato/ui-component-library'
import styled from 'styled-components'

export const StyledNewsViewSelection = styled.div`
  display: flex;
  column-gap: 8px;

  button {
    font-weight: ${JATOTheme.fontWeights.medium};
    background-color: ${JATOTheme.colors.midGrey};
    border-radius: 6px;
    column-gap: 8px;
  }
`
